module.exports = __webpack_public_path__ + "img/messages.147005e4.svg";